import type { IconData } from '@stacksjs/iconify-core'

export const linkAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M48 256a80.09 80.09 0 0 1 80-80h112v-32H128a112 112 0 0 0 0 224h112v-32H128a80.09 80.09 0 0 1-80-80m336-112H272v32h112a80 80 0 0 1 0 160H272v32h112a112 112 0 0 0 0-224\"/><path fill=\"currentColor\" d=\"M140 240.652h232v32H140z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default linkAlt
